import { Input } from 'antd';

const ReponseCourte = ({ disabled = false,value='',onChange }) => {
  return (
    <Input variant='underlined'
      placeholder="Réponse courte"
      disabled={disabled} 
      style={{ width: '56%' }}
       value={value}
      onChange={e => onChange(e.target.value)}
    />
  );
};
 
export default ReponseCourte;
